import { render, staticRenderFns } from "./SendVerificationEmail.vue?vue&type=template&id=ffa18a0a&"
import script from "./SendVerificationEmail.vue?vue&type=script&lang=js&"
export * from "./SendVerificationEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SendVerificationEmail.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports